import { isSavage } from '~/shared/utils/brandNameHelper';
import { FableticsCtaBuilderComponent } from '~/techstyle-shared/react-builder-models';

// Start with base variants that should be available for all brands
export const CtaVariantHumanToThemeMapping = {
  // Base variants, all should be converted to camelCase, except for text_link
  Primary: 'primary',
  Secondary: 'secondary',
  Other: 'other',
  'Text Link': 'text_link',
};

// Add SXF-specific variants only if the brand is Savage
if (isSavage()) {
  Object.assign(CtaVariantHumanToThemeMapping, {
    // SXF variants, should be converted to camelCase
    'Primary Dark': 'primaryDark',
    'Primary Light': 'primaryLight',
    'Primary Lavender': 'primaryLavender',
    'Secondary Dark': 'secondaryDark',
    'Secondary Light': 'secondaryLight',
    'Secondary Lavender': 'secondaryLavender',
    'Tertiary Dark': 'tertiaryDark',
    'Tertiary Light': 'tertiaryLight',
  });
}

const modifiedComponent = {
  ...FableticsCtaBuilderComponent,
  inputs: FableticsCtaBuilderComponent.inputs.map((input) => {
    if (input.name === 'variant') {
      return {
        ...input,
        enum: Object.keys(CtaVariantHumanToThemeMapping),
        defaultValue: 'Primary',
      };
    }
    return input;
  }),
};

export const BuilderCtaConfig = {
  ...modifiedComponent,
};
